import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { CenterFocusStrong, CenterFocusWeak } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"
import GroupingMenu from "components/grouping-menu"
import ExcelDownload from "components/excel-download"

import "./style.scss"
import { TOOLTIP_ENTER_DELAY_MS } from "helpers/constants"

export default function ContributorsOptions(props) {
  const {
    csvData,
    trackExcelDownload,
    availableRollups,
    showNotHeld,
    toggleShowNotHeld,
    currentGrouping,
    setGrouping,
    groupBy,
    selectedGroup,
    contributorsSummaryText,
  } = props

  const getDownloadTitle = () => {
    if (selectedGroup) {
      return "Download Group Contributors"
    } else if (groupBy) {
      return "Download Groups"
    }
    return "Download Contributors"
  }

  return <div className="components_contributors-panel-header">
    <div className="options-count">
      {contributorsSummaryText}
    </div>
    <div className="options-actions">
      {toggleShowNotHeld && <Tooltip enterDelay={TOOLTIP_ENTER_DELAY_MS} title={`${showNotHeld ? "Hide" : "Show"} Benchmark Names`}>
        <IconButton
          onClick={() => toggleShowNotHeld(!showNotHeld)}
          className="contributor-groups toggle-not-held"
          size="large"
        >
          {showNotHeld ? <CenterFocusWeak /> : <CenterFocusStrong />}
        </IconButton>
      </Tooltip>}
      <GroupingMenu {...{ availableRollups, currentGrouping, setGrouping }} />
      {csvData.data.length && <ExcelDownload title={getDownloadTitle()} {...csvData} track={trackExcelDownload} />}
    </div>
  </div>
}

ContributorsOptions.propTypes = {
  setGrouping: PropTypes.func.isRequired,
  availableRollups: PropTypes.array.isRequired,
  showNotHeld: PropTypes.bool,
  trackExcelDownload: PropTypes.func,
  csvData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.array),
    fileName: PropTypes.string,
    type: PropTypes.string,
  }),
  currentGrouping: PropTypes.object,
  contributorsSummaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  toggleShowNotHeld: PropTypes.func,
  groupBy: PropTypes.string,
  selectedGroup: PropTypes.object,
}
